import styled from '@mui/material/styles/styled';
import StyleService from '@/services/StyleService/StyleService';
import backgroundImage from '../../assets/images/banner-bg-dark-blue.jpg';
import ftSeriateLogo from '../../assets/images/ftSeriate-logo.png';

export const Container = styled('div', {
  shouldForwardProp: StyleService.shouldNotForwardProps(['backgroundColor', 'backgroundImage']),
})<{
  backgroundImage?: string;
  backgroundColor?: string;
}>(({ theme, backgroundImage: backgroundImageCustom, backgroundColor }) => ({
  flex: 1,
  display: 'flex',
  flexDirection: 'column',
  minHeight: '100vh',
  position: 'relative',
  overflow: 'hidden',
  ...(!backgroundImageCustom
    ? { backgroundColor: backgroundColor || theme.palette.background.navigation }
    : {
        backgroundImage: `url('${backgroundImageCustom || backgroundImage}')`,
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover',
        backgroundPosition: 'center center',
      }),
}));

export const BackgroundImage = styled('div', {
  shouldForwardProp: StyleService.shouldNotForwardProps(['backgroundImage', 'backgroundColor']),
})<{
  backgroundImage?: string;
  backgroundColor?: string;
}>(({ theme, backgroundImage: backgroundImageCustom, backgroundColor }) => ({
  width: '100%',
  height: '30rem',
  flexShrink: 0,
  ...(backgroundColor
    ? { backgroundColor }
    : {
        backgroundImage: `url('${backgroundImageCustom || backgroundImage}')`,
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover',
        backgroundPosition: 'center center',
      }),

  [theme.breakpoints.down('md')]: {
    height: '30%',
  },
}));

export const Content = styled('div')(({ theme }) => ({
  position: 'absolute',
  top: '20%',
  left: 0,
  right: 0,
  display: 'flex',
  gap: '4rem',
  padding: '2rem',
  justifyContent: 'center',

  [theme.breakpoints.down('lg')]: {
    gap: '2rem',
  },

  [theme.breakpoints.down('md')]: {
    flexDirection: 'column',
    justifyContent: 'flex-start',
    paddingBottom: '2rem',
  },
}));

export const TextContainer = styled('div', {
  shouldForwardProp: StyleService.shouldNotForwardProps(['isOtp']),
})<{ isOtp?: boolean }>(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  color: theme.palette.background.primary,
  gap: '1.94rem',
  maxWidth: '40rem',
  flex: 1,
  marginTop: '3rem',

  [theme.breakpoints.down('md')]: {
    display: 'none',
  },
}));

export const FormContainer = styled('div')(({ theme }) => ({
  backgroundColor: theme.palette.other.white,
  padding: '2.5rem 3.75rem',
  display: 'flex',
  flexDirection: 'column',
  width: '100%',
  maxWidth: '32rem',
  gap: '2rem',
  borderRadius: '0.2rem',
  boxShadow: '0 0.5rem 2.5rem rgba(0, 0, 0, 0.15)',
  zIndex: 1,

  [theme.breakpoints.down('md')]: {
    padding: '1.5rem 1.25rem',
    margin: '0.75rem',
    gap: '1.5rem',
    maxWidth: '100%',
  },

  '@media screen and (max-height: 1020px)': {
    padding: '2rem 3rem',
  },
  '@media screen and (max-height: 768px)': {
    padding: '1.5rem 2.5rem',
    gap: '1.5rem',
  },
}));

export const DynamicLogo = styled('img')<{ src: string }>(({ theme }) => ({
  [theme.breakpoints.down('md')]: {
    width: '6.25rem',
    height: '1.125rem',
  },
}));

export const DefaultLogo = styled('img')(() => ({
  maxWidth: '14rem',
  height: 'auto',
}));

export { ftSeriateLogo };
